<template>
  <d-modal v-if="orderDetails !== null" @close="handleClose">
    <d-modal-header>
      <d-modal-title>{{ orderDetails.name }}</d-modal-title>
    </d-modal-header>
    <d-modal-body class="mt-0 pt-0 pb-4">
      <odd-label>Call</odd-label>
      <d-link class="btn btn-primary" :href="`tel:${orderDetails.phone}`">
        <i class="material-icons mr-1">phone</i>
        {{ orderDetails.phone }}
      </d-link>
      <odd-label>Email</odd-label>
      <d-link
        class="btn btn-primary"
        :href="`mailto:${orderDetails.user_email}`"
      >
        <i class="material-icons mr-1">email</i>
        {{ orderDetails.user_email }}
      </d-link>
    </d-modal-body>
  </d-modal>
</template>

<script>
export default {
  data() {
    return {
      order: null
    };
  },
  props: {
    orderDetails: {
      type: Object,
      default: null
    }
  },
  methods: {
    handleClose() {
      this.$emit("close");
    }
  }
};
</script>
